import React from 'react';
import {t} from '@lingui/core/macro';

import Delete from 'shared/ui/icons/General/Delete';
import Edit from 'shared/ui/icons/General/Edit';
import Suspend from 'shared/ui/icons/General/Suspend';
import TurnOn from 'shared/ui/icons/General/TurnOn';
import Tags from 'shared/ui/icons/TablesMenu/Tags';

import {IMassOperationAction} from './MassOperations';

export const getCommonMassOperationActions = (): IMassOperationAction[] => [
    {
        value: 'start',
        label: t`включение`,
        icon: <TurnOn/>,
        title: t`Включить`,
    },
    {
        value: 'stop',
        label: t`остановка`,
        icon: <Suspend/>,
        title: t`На паузу`,
    },
    {
        value: 'edit',
        label: t`изменение`,
        icon: <Edit/>,
        title: t`Изменить настройки`,
    },
    {
        value: 'delete',
        label: t`удаление`,
        icon: <Delete/>,
        title: t`Удалить`,
    },
    {
        value: 'tags',
        label: t`добавление тегов`,
        icon: <Tags/>,
        title: t`Добавить теги`,
    },
];
